import {createAction} from 'redux-actions';
import {getContentItemViewMetadata} from '@pluto/rest';

export const CONTENT_ITEM_VIEW_METADATA_SET = 'CONTENT_ITEM_VIEW_METADATA_SET';
export const CONTENT_ITEM_VIEW_METADATA_RESET = 'CONTENT_ITEM_VIEW_METADATA_RESET';

export const setContentItemViewMetadataAction = createAction<Promise<any>, number>(
    CONTENT_ITEM_VIEW_METADATA_SET,
    async (id: number) => {
        return await getContentItemViewMetadata(id);
    }
);

export const resetContentItemViewMetadataAction = createAction(
    CONTENT_ITEM_VIEW_METADATA_RESET
);
